import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export var BaseCta = function BaseCta(_ref) {
  var children = _ref.children,
      className = _ref.className,
      classOptions = _ref.classOptions,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'a' : _ref$tag,
      _ref$tooltipProps = _ref.tooltipProps,
      tooltipProps = _ref$tooltipProps === void 0 ? {} : _ref$tooltipProps,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "classOptions", "tag", "tooltipProps"]);

  var Tag = tag;
  return React.createElement(Tag, _extends({
    className: classNames('bt bt--sm bt--text-sm schedule-item__cta', className, classOptions)
  }, tooltipProps, otherProps), children);
};
BaseCta.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  classOptions: PropTypes.object,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  tooltipProps: PropTypes.exact({
    'data-tooltip': PropTypes.string
  })
};